import React, { useState, useEffect } from 'react';
import taskService from '../../services/taskService';
import { Task, TaskFilterParams } from '../../types/task.types';
import TaskFormModal from './TaskFormModal';
import TaskDetailSlideOver from './TaskDetailSlideOver';
import TaskTable from './TaskTable';

interface TaskListProps {
  clientId?: number;
  dealId?: number;
  showFilters?: boolean;
}

const TaskList: React.FC<TaskListProps> = ({ clientId, dealId, showFilters = true }) => {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedTask, setSelectedTask] = useState<Task | null>(null);
  const [showDetailSlideOver, setShowDetailSlideOver] = useState(false);
  const [selectedTasks, setSelectedTasks] = useState<number[]>([]);
  const [filters, setFilters] = useState<TaskFilterParams>({
    page: 1,
    limit: 20,
    sortBy: 'dueDateTime',
    sortOrder: 'asc',
    clientId,
    dealId,
  });

  useEffect(() => {
    loadTasks();
  }, [filters, clientId, dealId]);

  useEffect(() => {
    // Update filters when clientId or dealId changes
    setFilters(prev => ({
      ...prev,
      clientId,
      dealId,
    }));
  }, [clientId, dealId]);

  const loadTasks = async () => {
    try {
      setLoading(true);
      const response = await taskService.getTasks(filters);
      setTasks(response.data);
    } catch (error) {
      console.error('Error loading tasks:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleTaskClick = (task: Task) => {
    setSelectedTask(task);
    setShowDetailSlideOver(true);
  };

  const handleTaskUpdated = () => {
    loadTasks();
  };

  return (
    <div>
      {/* Task Table */}
      <TaskTable
        tasks={tasks}
        loading={loading}
        selectedTasks={selectedTasks}
        onTaskClick={handleTaskClick}
        onSelectionChange={setSelectedTasks}
        onTaskUpdated={handleTaskUpdated}
      />

      {/* Task Detail Slide Over */}
      {showDetailSlideOver && selectedTask && (
        <TaskDetailSlideOver
          task={selectedTask}
          onClose={() => {
            setShowDetailSlideOver(false);
            setSelectedTask(null);
          }}
          onTaskUpdated={handleTaskUpdated}
        />
      )}
    </div>
  );
};

export default TaskList;

